import React from "react";
import styled from "styled-components";

import { HSpace } from "@examspark/common-ui";
import { StyledCommonProps } from "@examspark/common-ui/dist/utils/styled";

const Styled = styled(HSpace)`
  color: #777;
  font-size: 1.4rem;
  justify-content: center;
  align-items: center;
  padding: 2rem;

  // we want NoResults to be the same height as Loading
  min-height: 6.4rem;

  svg {
    width: 4rem;
    fill: currentColor;
  }
`;

type NoResultsProps = StyledCommonProps & {
  icon?: React.ReactNode;
  children?: React.ReactNode;
};

const NoResults = (props: NoResultsProps) => {
  return (
    <Styled className={props.className}>
      {!!props.icon && <div>{props.icon}</div>}
      <div>{props.children}</div>
    </Styled>
  );
};

export default NoResults;
